import { Fragment, ReactElement } from 'react';
import ResearchMarriageDetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage/detail';

const ResearchMarriageDetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageDetailNotificationsCivilStatusShared />
    </Fragment>
  );
};

ResearchMarriageDetailNotificationsCivilStatusPage.displayName =
  'Research Marriage Detail Notifications CivilStatusPage component';

export default ResearchMarriageDetailNotificationsCivilStatusPage;
